import { Group, Stack } from '@mantine/core';
import StyledTextInput from '@/components/StyledInputFields/StyledTextInput.tsx';
import StepFieldsRemoveButton from '@/pages/Editor/components/StepFieldsRemoveButton.tsx';
import SingleDataInputSelectorInner from '@/pages/Editor/components/SharedFields/DataInputSelector/SingleDataInputSelectorInner.tsx';
import { ErrorBoundaryInputBinding, FailureHandlerStep } from '@/types/automationSteps.ts';
import { DataInputType } from '@/types/automationFields.ts';
import { STEP_FIELD_MAX_LENGTH } from '@/utils/constants.ts';

type Props = {
  binding: ErrorBoundaryInputBinding;
  label: string;
  step: FailureHandlerStep;
  onChange: (binding: ErrorBoundaryInputBinding) => void;
  onDelete: () => void;
};

export function FailureHandlerInputBindingFields({
  binding,
  label,
  step,
  onChange,
  onDelete,
}: Props) {
  return (
    <Stack style={{ borderColor: '#ECECED', borderWidth: 1, borderRadius: 5 }} bg="#F6F6F6" p="xs" gap="xs">
      <Group gap="xs" wrap="nowrap" align="start">
        <StyledTextInput
          label="Name"
          value={binding.name}
          placeholder={label}
          onChange={(event) => onChange({ ...binding, name: event.currentTarget.value.replace(/[/\n]/g, '') })}
          required
          maxLength={STEP_FIELD_MAX_LENGTH}
          w="100%"
        />
        <StepFieldsRemoveButton onDelete={onDelete} />
      </Group>
      <SingleDataInputSelectorInner
        step={step}
        label="Upstream dynamic input"
        dataInput={binding.data_input}
        allowedDataInputTypes={[DataInputType.Dynamic]}
        onChange={(dataInput) =>
          onChange({
            ...binding,
            data_input: dataInput as ErrorBoundaryInputBinding['data_input'],
          })
        }
      />
    </Stack>
  );
}
